import {
  FileText, Lightbulb, Calendar
} from 'lucide-react';

export const ACADEMIC_SECTIONS = [
  {
    id: "publications",
    title: "Publications",
    icon: FileText,
    category: "academic",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No publications added yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 45,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: true,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["academic", "research"],
    badges: ["Recommended"],
    fields: [
      { name: "title", label: "Paper / Article Title", type: "text", required: true, placeholder: "e.g. Distributed Consensus in Web APIs" },
      { name: "publisher", label: "Publisher / Journal", type: "text", required: true, placeholder: "e.g. IEEE Transactions" },
      { name: "date", label: "Publication Date", type: "text", required: false, placeholder: "e.g. Oct 2024" },
      { name: "url", label: "URL Link", type: "url", required: false, placeholder: "e.g. https://doi.org/..." },
      { name: "description", label: "Abstract / Overview", type: "textarea", required: false, placeholder: "Proposed a novel Raft consensus derivative..." }
    ],
    defaultData: { title: "", publisher: "", date: "", url: "", description: "" }
  },
  {
    id: "patents",
    title: "Patents",
    icon: Lightbulb,
    category: "academic",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No patents listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 40,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: false,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["research"],
    badges: [],
    fields: [
      { name: "title", label: "Patent Title / System", type: "text", required: true, placeholder: "e.g. Dynamic Cache Allocation Engine" },
      { name: "office", label: "Patent Office / ID", type: "text", required: true, placeholder: "e.g. USPTO US12345A" },
      { name: "date", label: "Date Filed / Issued", type: "text", required: false, placeholder: "e.g. Sep 2024" },
      { name: "url", label: "Patent URL", type: "url", required: false, placeholder: "e.g. https://patents.google.com/..." },
      { name: "description", label: "Description", type: "textarea", required: false, placeholder: "Engine allocating cache segments based on incoming rate semantics..." }
    ],
    defaultData: { title: "", office: "", date: "", url: "", description: "" }
  },
  {
    id: "conferences",
    title: "Conferences",
    icon: Calendar,
    category: "academic",
    allowMultiple: true,
    defaultVisible: false,
    emptyState: "No conferences listed yet.",
    editorComponent: "GenericListEditor",
    rendererComponent: "GenericListRenderer",
    layout: {
      preferredColumn: "main",
      priority: 35,
      collapsible: true,
      allowPageBreak: true,
      keepTogether: false,
    },
    capabilities: {
      aiRewrite: false,
      reorder: true,
      duplicate: true,
      deletable: true,
      hideable: true,
      exportable: true,
    },
    recommendedFor: ["academic", "research"],
    badges: [],
    fields: [
      { name: "name", label: "Conference Name", type: "text", required: true, placeholder: "e.g. NeurIPS 2024" },
      { name: "role", label: "Role / Contribution", type: "text", required: true, placeholder: "e.g. Program Committee / Attendee" },
      { name: "date", label: "Date Attended", type: "text", required: false, placeholder: "e.g. Dec 2024" },
      { name: "description", label: "Activities / Notes", type: "textarea", required: false, placeholder: "Participated in workshops on deep representation models..." }
    ],
    defaultData: { name: "", role: "", date: "", description: "" }
  }
];
